import Component from '@glimmer/component';

// keep empty component because it's passed to emoji-name-popup as ctx
export default class EmojiSendersHeader extends Component {}
